import config from '../config';
import { request } from '../utils/request';

const abilitiesDomain = `${config.host}${config.apiRouter.abilities}`;

const api = {
  get_ability_by_appid (data) {
    return request.post(`${abilitiesDomain}/GetAbilityByAppid`, data);
    // http://dev.open.govcloud.qq.com/cgi/account/v2/GetLoginUserInfo
  },
  // GetAbilitiesList
  get_abilities_list (data) {
    return request.post(`${abilitiesDomain}/GetAbilitiesList`, data);
  },

  // ApplyAppAbility
  apply_app_ability (data) {
    return request.post(`${abilitiesDomain}/ApplyAppAbility`, data);
  },

  // GetAppAbilitiesList
  get_app_abilities_list (data) {
    return request.post(`${abilitiesDomain}/GetAppAbilitiesList`, data);
  },

  // AuditAppAbility
  audit_app_ability (data) {
    return request.post(`${abilitiesDomain}/AuditAppAbility`, data);
  },

  // GetAppAbilityAuditHistory
  get_app_ability_audit_history (data) {
    return request.post(`${abilitiesDomain}/GetAppAbilityAuditHistory`, data);
  },

  get_project_undisposed_ability (data) {
    return request.post(`${abilitiesDomain}/GetProjectUndisposedAbility`,
      data);
  },

  get_factory_undisposed_ability (data) {
    return request.post(`${abilitiesDomain}/GetFactoryUndisposedAbility`,
      data);
  },

  // GetAppAbilityApplyDetail
  get_app_ability_apply_detail (data) {
    return request.post(`${abilitiesDomain}/GetAppAbilityApplyDetail`, data);
  },
};
export default api;
